'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.remoteUserIdsCurrentlyViewingSelector = exports.boardSharingPopupSelector = exports.boardSharingUtilSelector = exports.isSharedUsersError = exports.isSharedUsersLoading = exports.getSharedUsersResourceState = exports.usersCurrentlyViewingSelector = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Selectors


// Utils


var _reselect = require('reselect');

var _permissionsService = require('../../../../utils/permissions/permissionsService');

var _usersSelector = require('../../../../user/usersSelector');

var _milanoteReselect = require('../../../../utils/milanoteReselect/milanoteReselect');

var _userUtil = require('../../../../user/userUtil');

var _resourceUtil = require('../../../../utils/services/http/resources/resourceUtil');

var _immutableHelper = require('../../../../../common/utils/immutableHelper');

var _popupOpenSelector = require('../../../../components/popupPanel/popupOpenSelector');

var _popupOpenSelector2 = _interopRequireDefault(_popupOpenSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var usersCurrentlyViewingSelector = exports.usersCurrentlyViewingSelector = (0, _reselect.createSelector)(function (state, ownProps) {
    return ownProps.currentBoardId;
}, function (state) {
    return state.get('users');
}, function (currentBoardId, users) {
    return users.filter(function (user) {
        return (0, _userUtil.isOnline)(user) && user.get('currentBoardId') === currentBoardId;
    });
});

var getSharedUserIds = (0, _reselect.createSelector)(_permissionsService.currentBoardPermissionsSelector, _permissionsService.getSharedUsers);

var getSharedUsersResourceState = exports.getSharedUsersResourceState = (0, _usersSelector.makeFilteredUsersResourcesSelector)(getSharedUserIds);

var getSharedUsersSelector = (0, _reselect.createSelector)(getSharedUserIds, function (state) {
    return state.get('users');
}, _immutableHelper.getMany);

var isSharedUsersLoading = exports.isSharedUsersLoading = (0, _reselect.createSelector)(getSharedUserIds, getSharedUsersSelector, getSharedUsersResourceState, function (sharedUserIds, sharedUsers, sharedUserResourcesState) {
    return sharedUserIds.length - sharedUsers.size > 1 || sharedUserResourcesState.filter(_resourceUtil.isFetching).size > 1;
});

var isSharedUsersError = exports.isSharedUsersError = (0, _reselect.createSelector)(getSharedUsersResourceState, function (sharedUserResourcesState) {
    return sharedUserResourcesState.some(_resourceUtil.isError);
});

var boardSharingUtilSelector = exports.boardSharingUtilSelector = (0, _reselect.createSelector)(function (state, ownProps) {
    return state.getIn(['elements', ownProps.currentBoardId]);
}, _permissionsService.currentBoardPermissionsSelector, (0, _popupOpenSelector2.default)('sharing'), _permissionsService.currentBoardUserPermissionsSelector, usersCurrentlyViewingSelector, function (state) {
    return state.getIn(['app', 'popup', 'sharing']);
}, getSharedUserIds, function (currentBoard, boardPermissions, popupOpen, userPermissions, usersCurrentlyViewing, sharingPopupState, sharedUserIds) {
    var sharedUserCount = sharedUserIds.length;
    var isRootBoard = currentBoard && currentBoard.getIn(['location', 'rootBoard']);

    return {
        popupOpen: popupOpen,
        boardPermissions: boardPermissions,
        sharedUserCount: sharedUserCount,
        sharedUserIds: sharedUserIds,
        isRootBoard: isRootBoard,
        userPermissions: userPermissions,
        usersCurrentlyViewing: usersCurrentlyViewing,
        sharingPopupState: sharingPopupState
    };
});

var boardSharingPopupSelector = exports.boardSharingPopupSelector = (0, _reselect.createSelector)(boardSharingUtilSelector, getSharedUsersSelector, isSharedUsersLoading, isSharedUsersError, function (boardSharingUtilState, sharedUsers, isLoading, isUserError) {
    return _extends({}, boardSharingUtilState, {
        sharedUsers: sharedUsers,
        isLoading: isLoading,
        isUserError: isUserError
    });
});

var remoteUserIdsCurrentlyViewingSelector = exports.remoteUserIdsCurrentlyViewingSelector = (0, _milanoteReselect.createShallowSelector)(usersCurrentlyViewingSelector, function (state) {
    return state.getIn(['app', 'currentUser', '_id']);
}, function (users, currentUserId) {
    return users.filter(function (user) {
        return user.get('_id') !== currentUserId;
    }).keySeq().toArray();
});


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/sharing/sharingUtilSelector.js
// module id = 318
// module chunks = 0